import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import TextInput from './TextInput';
import FormikControlledComboBox from './ComboBox';
import COUNTRIES from './countriesList';
import s from './AddressInputFields.module.scss';

/**
 * A group of input fields for entering an address
 */
function AddressInputFields(props) {
  const { isRequired, namePrefix } = props;
  return (
    <div className={s.input4md}>
      <Field
        name={`${namePrefix}.street`}
        labelMsg="offerWizard.StepSomeInformation.street"
        component={TextInput}
        autoComplete="address-line1"
        required={isRequired}
      />
      <div className={`${s.input4md} ${s.ZIP}`}>
        <Field
          name={`${namePrefix}.zipcode`}
          labelMsg="offerWizard.StepSomeInformation.zipcode.label"
          component={TextInput}
          autoComplete="postal-code"
          required={isRequired}
        />
        <Field
          name={`${namePrefix}.town`}
          labelMsg="offerWizard.StepSomeInformation.town.label"
          component={TextInput}
          autoComplete="address-level2"
          required={isRequired}
        />
      </div>
      <Field
        name={`${namePrefix}.country`}
        component={FormikControlledComboBox}
        options={COUNTRIES}
        labelMsg="offerWizard.StepSomeInformation.country"
        isRequired={isRequired}
      />
    </div>
  );
}

AddressInputFields.propTypes = {
  /** Prefix for the input names. E.g. passing "myInput" will cause the street input
   * to be named "myInput.street" */
  namePrefix: PropTypes.string.isRequired,
  /** Is the address required? */
  isRequired: PropTypes.bool.isRequired,
};

export default AddressInputFields;
